import React, { useState, useEffect } from 'react'
import { ReportHeading, LoaderWrapper, ReportOuterWrapper } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery, useConditionalQuery } from '../../../../hooks'
import { CardOuterWrapper, IconButtonGrouped } from './style'
import RelativeBrands from './relativeBrands'
import { exportExcel_addPercentage } from '../../../../util'
import { IconGraphBtn, IconListBtn } from '../../../../assets/images/icons'
import GraphGridTab from '../comparisonViewDeepDiveNew/graphGridTab'

const SegmentOverview = (props) => {
  const [show, setShow] = useState('graph')
  const [graphPieData, setGraphPieData] = useState([])
  const [pptData, setPptData] = useState([])
  const [reportExcelData, setReportExcelData] = useState()
  const [eventCount, setEventCount] = useState(1)
  const {updateSubLhsApiLoaded} = useUpdateLhs()
  const [maxValue, setMaxValue] = useState(0);
  const [containerWidth, setContainerWidth] = useState(2000);
  const componentType = props.InsightsElementType === 'SegmentOverview' ? 'SegmentOverview' : 'AllRelativeBrandsAnalysis'
  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: 
        componentType === 'SegmentOverview'
          ? ReportsService.getSegmentOverviewElement
          : ReportsService.getRelativeBrandsAnalysis,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useConditionalQuery(useReactQueryObject, props)

  useEffect(() => {
    setTimeout(() => {
      setEventCount((p) => p + 1)
    }, 2000)
  }, [graphPieData])

  const onSuccessFunc = (resp) => {
    if (componentType === 'SegmentOverview') {
      const pieData = resp.map((d) => {
        return { name: String(d.SegmentName), value: d.SegmentValue }
      })
      .sort((a, b) => b.value - a.value);
      
      const checkPieTotal = pieData.map((d) => d.value).reduce((a, b) => a + b, 0);
      if (checkPieTotal < 100) {
        pieData.push({ name: 'REMAINING_VALUE', value: 100 - checkPieTotal })
      }
      
      setMaxValue(pieData.length > 0 ? pieData[0].value : 0);
      setGraphPieData(pieData)
      setPptData({content : pieData});

      setTimeout(() => {
        updateSubLhsApiLoaded(props)
      }, 2000)

      setReportExcelData({
        heading: ['Segment Names'],
        values: resp
        .sort((a, b) => b.SegmentValue - a.SegmentValue)
        .map((d) => {
          return [{ value: (d.SegmentName) }, exportExcel_addPercentage(d.SegmentValue)]
        }),
      })
    } else {
      // AllRelativeBrandsAnalysis
      const pieData = resp.map((d) => {
        return { name: d.BrandName, value: d.BrandPercent }
      })
      .sort((a, b) => b.value - a.value);
      
      const checkPieTotal = pieData.map((d) => d.value).reduce((a, b) => a + b, 0);

      if (checkPieTotal < 100) {
        pieData.push({ name: 'REMAINING_VALUE', value: 100 - checkPieTotal })
      }

      setMaxValue(pieData.length > 0 ? pieData[0].value : 0);
      setGraphPieData(pieData)
      setPptData({
        content : pieData
      });
      setTimeout(() => {
        updateSubLhsApiLoaded(props)
      }, 2000)
      setReportExcelData({
        heading: ['Brand Names'],
        values: resp.map((d) => {
          return [{ value: d.BrandName }, exportExcel_addPercentage(d.BrandPercent)]
        }),
      })
    }
  }

  const onBtnClick = (activeTab) => {
    setShow(activeTab);
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  useEffect(() => {
    // measure width of element with id = props.type
    if (!props.type) return;

    let mounted = true;
    const measureWidth = () => {
      const el = document.getElementById(props.type);
      if (el) {
        const width = el.offsetWidth || el.getBoundingClientRect().width;
        setContainerWidth(width);
      }
    };

    // try measuring immediately
    measureWidth();
    setTimeout(measureWidth, 1000);
    setTimeout(measureWidth, 2000);

    const onResize = () => measureWidth();
    window.addEventListener('resize', onResize);

    return () => {
      mounted = false;
      window.removeEventListener('resize', onResize);
    };
  // re-run when props.type or graph data changes so measurement happens after render
  }, [props.type, graphPieData.length, maxValue]);

  return (
    <>
      {!!graphPieData?.length && (
        <>
          <ReportHeading
            resetInsightHeight={eventCount}
            downloadId={props?.type}
            {...props}
            pptData={pptData}
            downloadIdData={reportExcelData}
            additionalButton={<GraphGridTab classname='segment-overview-btn' onClick={onBtnClick} show={show} GraphIcon={IconGraphBtn} TableIcon={IconListBtn} disableActiveBg={true} />}
          />
          <ReportOuterWrapper type={props.InsightsElementType}>
            <CardOuterWrapper id={props.type}>
              <LoaderWrapper
                loadOnlyApi={props.loadOnlyApi}
                isLoading={isLoading}
                isSuccess={isSuccess}
                isError={isError}
                error={error}
              >
                {!!graphPieData?.length && containerWidth>0 &&
                  <RelativeBrands
                    containerWidth={containerWidth}
                    isExtraColor={props.isExtraColor}
                    graphPieData={graphPieData}
                    showLegendToolTip={true}
                    activeTab={show}
                    maxValue={maxValue}
                    id={props.type}
                  />
                }
              </LoaderWrapper>
            </CardOuterWrapper>
          </ReportOuterWrapper>
        </>
      )}
    </>
  )
}

export default SegmentOverview;